import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface AlertDialogData {
  title: string;
  msg: string;
  closeBtn: string;
  type: number; // 0-question | 1-info | 2-warn | 3-error
}

@Component({
  standalone: false,
  selector: "dlg-alert",
  templateUrl: "./z-dlg-alert.component.html",
  styleUrls: ["./z-dlg-alert.component.css"],
})
export class dlgAlert implements OnInit {
  /** Maps numeric “type” → icon file */
  iconMap: string[] = [
    "assets/img/dlgQuestion.png",
    "assets/img/dlgInfo.png",
    "assets/img/dlgWarning.png",
    "assets/img/dlgError.png",
  ];

  /** Maps numeric “type” → Bootstrap button class */
  btnClassMap: string[] = [
    "btn-primary", // question
    "btn-info", // info
    "btn-warning", // warning
    "btn-danger", // error
  ];

  constructor(
    public dialogRef: MatDialogRef<dlgAlert>,
    @Inject(MAT_DIALOG_DATA) public oData: AlertDialogData
  ) {}

  ngOnInit(): void {}

  closeAlert(): void {
    this.dialogRef.close();
  }
}
